import { ContentNumber } from './ContentNumber';

export type { TypeContentNumberProps } from './types';
export default ContentNumber;
